/*
  Creative Cycles Workshop collection toolbar (30 Oct 2026). Section ccw-collection-grid.liquid.

  Collections and Filter are <details> panels, so they open and close without this file. This adds
  what details cannot do alone: one panel open at a time, close on Escape, on the cross, and on a
  tap outside the panel (the dimmed page on a phone), and the page stops scrolling behind a sheet.

  It also clips a long collection description to two lines on a phone, with Read more.
*/
(() => {
  const PHONE = window.matchMedia('(max-width: 749px)');

  const tool = document.querySelector('[data-ccw-tool]');
  if (tool) {
    const pops = [...tool.querySelectorAll('[data-ccw-pop]')];

    const lockScroll = () => {
      const anyOpen = pops.some((pop) => pop.open);
      document.documentElement.classList.toggle('ccw-sheet-open', anyOpen && PHONE.matches);
    };

    const close = (pop) => {
      if (!pop.open) return;
      pop.open = false;
      pop.querySelector('summary')?.focus({ preventScroll: true });
    };

    pops.forEach((pop) => {
      pop.addEventListener('toggle', () => {
        if (pop.open) {
          pops.filter((other) => other !== pop).forEach((other) => { other.open = false; });
        }
        lockScroll();
      });
      pop.querySelector('[data-ccw-close]')?.addEventListener('click', () => close(pop));
    });

    document.addEventListener('click', (event) => {
      pops.forEach((pop) => {
        if (!pop.open) return;
        const panel = pop.querySelector('.ccw-tool__panel');
        const summary = pop.querySelector('summary');
        if (panel.contains(event.target) || summary.contains(event.target)) return;
        pop.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      pops.forEach(close);
    });

    PHONE.addEventListener('change', lockScroll);
  }

  // Read more: phone only, and only when the description is actually longer than two lines.
  const intro = document.querySelector('.ccw-template-collection .ccw-page-head__intro');
  if (intro) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ccw-intro-more';
    button.textContent = 'Read more';
    button.setAttribute('aria-expanded', 'false');
    intro.after(button);

    const measure = () => {
      if (intro.classList.contains('is-open')) return;
      button.hidden = !(PHONE.matches && intro.scrollHeight > intro.clientHeight + 1);
    };

    button.addEventListener('click', () => {
      const open = intro.classList.toggle('is-open');
      button.textContent = open ? 'Read less' : 'Read more';
      button.setAttribute('aria-expanded', String(open));
    });

    measure();
    PHONE.addEventListener('change', measure);
    window.addEventListener('load', measure);
  }
})();
